const moment = require('moment');

module.exports = {
    boolSimNao: function (value) {
        if (value) {
            return '<span class="badge badge-success">Sim</span>';
        } else {
            return '<span class="badge badge-danger">Não</span>';
        }
    },

    paymentStatus: function (value) {
        if (!value) {
            return '<label class="label label-success">Ativo</label>';
        } else {
            return '<label class="label label-danger">Cancelado</label>';
        }
    },

    signatureStatus: function (value) {
        if (value == 'I') {
            return '<label class="label label-success">Ativo</label>';
        } else if (value == 'C') {
            return '<label class="label label-danger">Cancelado</label>';
        } else {
          return '<label class="label label-warning">Sem Assinatura</label>';
        }
    },

    currency: function (value, currency, decimals) {
        var digitsRE = /(\d{3})(?=\d)/g
        value = parseFloat(value)
        if (!isFinite(value) || (!value && value !== 0)) return ''
        currency = currency != null ? currency : ''
        decimals = decimals != null ? decimals : 2
        var stringified = Math.abs(value).toFixed(decimals)
        var _int = decimals
            ? stringified.slice(0, -1 - decimals)
            : stringified
        var i = _int.length % 3
        var head = i > 0
            ? (_int.slice(0, i) + (_int.length > 3 ? '.' : ''))
            : ''
        var _float = decimals
            ? stringified.slice(-1 - decimals)
            : ''
        var sign = value < 0 ? '-' : ''
        return sign + currency + head +
            _int.slice(i).replace(digitsRE, '1,') +
            _float.replace(/./, ',')
    },

    paymentMethod: function (value) {
        if (value == 'money') {
            return '<span class="fa fa-money text-success"></span> Dinheiro';
        } else if (value == 'credit_card') {
            return '<span class="fa fa-credit-card text-danger"></span> Cartão de Crédito';
        } else if (value == 'bank_slip_' || value == 'bank_slip') {
            return '<span class="fa fa-barcode text-warning"></span> Boleto';
        } else if (value == 'bank_deposit') {
            return '<span class="fa fa-bank text-info"></span> Depósito bancário';
        } else {
            return '';
        }
    },

    formatDate: function (datetime, format) {
        moment.locale('pt-br');
        if (moment) {
            if (datetime != undefined && datetime != '') {
                return moment(datetime).format(format);
            } else {
                return '';
            }
        }
        else {
            return moment();
        }
    },

    isExpired: function (date) {
        moment.locale('pt-br');
        return moment().isAfter(date);
    }
}



// WEBPACK FOOTER //
// ./src/helpers/util.js